var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYourPass = function SvgYourPass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M.75.601h26v33h-26z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.25,
    y: 13.101,
    width: 9,
    height: 8.4,
    rx: 4,
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "bevel"
  })));
};
export default SvgYourPass;